export default __webpack_public_path__ + "static/media/suite-montanha2-4.7638cfed.webp";